import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
//import CryptoJS from "crypto-js";
import { getField, updateField } from "vuex-map-fields";
import { HTTP } from "@/http-common";
import { VodiaRequest } from "@/models/dealerPortal/VodiaRequest";
import { Dealer } from "@/models/Dealer";

export const { mapFields: mapNamptFields } = createHelpers({
  getterType: `nampt/getField`,
  mutationType: `nampt/updateField`
});

const state = {
  domain: null,
  session: null,
  account: null,
  lang: "en"
};

const actions = {
  pbxLogin({ commit, dispatch }, login) {
    return new Promise((resolve, reject) => {
      HTTP.post("/vodia/GetSession", {
        domain: login.domain
      })
        .then(data => {
          document.cookie = "session=" + data.data;
          commit("setSession", data.data);
          dispatch(
            "message/setMessage",
            new httpError({
              message: "logged in",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "unable to login : " + err,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject(err);
        });
    });
  },
  getCustomerDomains() {
    return new Promise((resolve, reject) => {
      HTTP.get("vodia/GetCustomerDomains")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getDomains({ state }) {
    return new Promise((resolve, reject) => {
      let request = {
        ip: "http://175.158.106.70",
        domain: "500134.70.vonex.biz",
        session: state.session,
        url: "rest/system/domaininfo"
      };
      HTTP.post("vodia/GetRequest", request)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getExtensions({ state }, domain) {
    return new Promise((resolve, reject) => {
      let request = {
        ip: "http://175.158.106.70",
        domain: domain,
        session: state.session,
        url: `rest/domain/${domain}/users`
      };
      HTTP.post("vodia/GetRequest", request)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getPBXExtensions({ state }, domain) {
    return new Promise((resolve, reject) => {
      HTTP.get(`vodia/GetExtensions/${domain}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getPBXExtension({ state }, request) {
    return new Promise((resolve, reject) => {
      HTTP.get(`vodia/GetExtension/${request.domain}/${request.id}`)
        .then(data => {
          if (data.data.data.dnd === "false") data.data.data.dnd = false;
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveExtension({ state, rootState }, data) {
    return new Promise((resolve, reject) => {
      data.dealer = rootState.dealer.dealer;
      data.method = "Post";
      HTTP.post("Vodia/UpdateExtension/", data)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  provisionPBXExtension({ state }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post(`vodia/ProvisionExtension/${data.domainName}/${data.id}`)
        .then(data => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Extension Provisioned",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getHuntGroups({ state }, domain) {
    return new Promise((resolve, reject) => {
      HTTP.get(`vodia/GetHuntGroups/${domain}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addHuntGroup({ rootState }, data) {
    return new Promise((resolve, reject) => {
      var request = new VodiaRequest();
      request.domainName = data.domain;
      request.formerContent = data.formerContent;
      request.content = data.content;
      request.identifier = data.content.name;
      request.dealer = rootState.dealer.dealer;
      request.method = "Add";
      HTTP.post("Vodia/AddHuntGroup/", request)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateHuntGroup({ rootState }, data) {
    return new Promise((resolve, reject) => {
      data.dealer = rootState.dealer.dealer;
      data.method = "Post";
      HTTP.post("Vodia/UpdateHuntGroup/", data)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getServiceFlags({ state }, domain) {
    return new Promise((resolve, reject) => {
      HTTP.get(`vodia/GetServiceFlags/${domain}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getServiceFlag({ state }, data) {
    return new Promise((resolve, reject) => {
      HTTP.get(`vodia/GetServiceFlag/${data.domain}/${data.id}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateServiceFlag({ state, rootState }, data) {
    return new Promise((resolve, reject) => {
      data.dealer = rootState.dealer.dealer;
      data.method = "Post";
      HTTP.post("Vodia/UpdateServiceFlag/", data)
        .then(result => {
          resolve(result.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getRegistrations({ state }, domain) {
    return new Promise((resolve, reject) => {
      HTTP.get(`vodia/GetRegistrations/${domain}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {
  setSession(state, session) {
    state.session = session;
  },
  setAccount(state, account) {
    state.account = account;
  },
  setDomain(state, domain) {
    state.domain = domain;
  },
  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
